export enum PaymentRequestStatus {
  PendingPayment = 10,
  PaymentComplete = 20,
  PaymentFailed = -10,
  Expired = -20,
}
